// src/utils/api/errorParser.ts
import { isObject } from 'lodash'

export const isValidJsonString = (str: string) => {
    try {
        JSON.parse(str)
        return true
    } catch {
        return false
    }
}

export const extractNestedMessage = (message: string): string => {
    if (isValidJsonString(message)) {
        const parsedMessage = JSON.parse(message) as Record<string, unknown>
        if (isObject(parsedMessage) && 'message' in parsedMessage && typeof parsedMessage.message === 'string') {
            return parsedMessage.message
        }
    }
    return message
}

export async function parseErrorResponse<E>(response: Response): Promise<string> {
    try {
        // Try JSON first
        if (response.headers.get('Content-Type')?.includes('application/json')) {
            const data = (await response.json()) as E

            if (isObject(data) && 'message' in data && typeof data.message === 'string') {
                return extractNestedMessage(data.message)
            }
            return JSON.stringify(data)
        }

        // Then try plain text
        const text = await response.text()

        // Check if text is actually JSON
        if (isValidJsonString(text)) {
            const parsed = JSON.parse(text) as E
            if (isObject(parsed) && 'message' in parsed && typeof parsed.message === 'string') {
                return parsed.message
            }
        }

        return text
    } catch (error) {
        return `Error parsing response: ${error instanceof Error ? error.message : String(error)}`
    }
}
